/* eslint-disable react/no-array-index-key */
/* eslint-disable arrow-body-style */
import {
  Stack,
  TextField,
  Button,
  Container,
  Typography,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TablePagination,
  LinearProgress,
  FormControl,
  Autocomplete,
  Collapse,
  Snackbar,
  Alert,
  RadioGroup,
  FormControlLabel,
  Radio,
  Grid,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  IconButton,
  InputLabel,
  Select,
  MenuItem,
  Chip,
  Checkbox,
  FormGroup,
  FormLabel,
  Tooltip,
  Box,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import LockResetIcon from '@mui/icons-material/LockReset';
import numeral from 'numeral';
import { Label } from 'reactstrap';
import React, { useEffect, useState } from 'react';
import { BarChart } from '@mui/x-charts/BarChart';
import styled from '@emotion/styled';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import BarChartIcon from '@mui/icons-material/BarChart';
import 'jspdf-autotable';
import './UserPrivilegesReports.css';
import NoimageFound from '../media/noimage.jpg';
import { ReactComponent as MastersIcon } from '../media/filter.svg';
import axios from '../axiosConfig';

// table header cell styles
const StyledTableCell = styled(TableCell)({
  color: 'white',
  fontWeight: '800',
  // textAlign: 'center',
  backgroundColor: '#219C90',
  padding: 'none',
  whiteSpace: 'nowrap',
});

const useStyles = styled((theme) => ({
  fileInput: {
    display: 'none',
  },
  chooseFileButton: {
    marginRight: theme.spacing(2),
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
}));

// Set the initial state for fromDate and toDate
const formatDateToinitialValues = (date) => {
  if (!date) {
    return '';
  }
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};
// Get the current date and 30 days before the current date
const currentDate = new Date();
const fromDateOnCurrentMonth = new Date(currentDate);
fromDateOnCurrentMonth.setDate(1);
// Convert fromDate and toDate objects to formatted date strings
const initialFromDate = formatDateToinitialValues(fromDateOnCurrentMonth);
const initialToDate = formatDateToinitialValues(currentDate);

const currentYear = new Date().getFullYear();
const selectedYears = Array.from({ length: 10 }, (_, i) => {
  const year = currentYear - i;
  return `${year}`;
});

const DailyReportTrackerReport = () => {
  // eslint-disable-next-line no-restricted-globals
  const tokent =
    'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJldmVudGxpc3QiOlt7IlVzZXJJRCI6IjEiLCJMb2dpbkNvZGUiOiIwMSIsIkxvZ2luTmFtZSI6IkFkbWluIiwiRW1haWxJZCI6ImFkbWluQGdtYWlsLmNvbSIsIlVzZXJUeXBlIjoiQURNSU4ifV0sImlhdCI6MTYzODM1NDczMX0.ZW6zEHIXTxfT-QWEzS6-GuY7bRupf2Jc_tp4fXIRabQ';

  // At the beginning of the component

  const classes = useStyles();
  const [fromDate, setfromDate] = useState(initialFromDate);
  const [toDate, setToDate] = useState(initialToDate);
  const [styleData, setstyleData] = useState([]);
  const [reportType, setReportType] = useState('Hour');
  const [styleSelected, setStyleSelected] = useState({
    Srhid: '0',
    StyleDescription: `${reportType === 'Style' ? 'All' : 'Select Style'}`,
    StyleNumber: '',
    Line_Name: '',
  });
  const [unitData, setUnitData] = useState([]);
  const [unitSelected, setUnitSelected] = useState({
    Unit_Id: '0',
    Unit_Name: 'All',
  });
  const [buyerData, setbuyerData] = useState([]);
  const [buyerSelected, setbuyerSelected] = useState({
    Buyer_Id: '0',
    Buyer_Name: 'All',
  });
  const [reportData, setreportData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [dateFilterEnabled, setDateFilterEnabled] = useState(false);

  const groupedPaymentsByName = {};

  const resetFilters = () => {
    setfromDate(initialFromDate);
    setToDate(initialToDate);
    setStyleSelected({
      Srhid: '0',
      StyleDescription: `${reportType === 'Style' ? 'All' : 'Select Style'}`,
      StyleNumber: '',
      Line_Name: '',
    });
    setUnitSelected({ Unit_Id: '0', Unit_Name: 'All' });
    setbuyerSelected({ Buyer_Id: '0', Buyer_Name: 'All' });
    setFilteredData([]);
    // setReportType('Hour');
  };

  const SwitchContainer = ({ children }) => (
    <Stack direction="row" justifyContent="start" alignItems="center" spacing={1}>
      {children}
    </Stack>
  );

  // other states
  const [openLoader, setOpenLoader] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const [showNoResultsSnackbar, setShowNoResultsSnackbar] = useState(false);
  const [noResultsMessage, setNoResultsMessage] = useState('');
  const [expanded, setExpanded] = React.useState(true);
  // pagination
  const totalRows = filteredData.length;
  const totalPages = Math.ceil(totalRows / rowsPerPage);
  const currentPage = Math.max(0, Math.min(page, totalPages - 1));
  const [efficiencyDetailsOpen, setEfficiencyDetailsOpen] = useState(false);
  const [selectedYear, setSelectedYear] = useState(selectedYears[0]);
  const [chartData, setChartData] = useState([]);

  const[overall,setOverall]=useState(false)

  // API Integration
  useEffect(() => {
    GetAllActiveProductionUnits();
    getAllStyles();
    GetAllActiveBuyers();
    formatDateToinitialValues();
  }, []);

  const handleEfficiencyDetailsClose = () => {
    setEfficiencyDetailsOpen(false);
  };

  const handleEfficiencyDetailsOpen = () => {
    setEfficiencyDetailsOpen(true);
  };

  // get all Active Buyer data
  const GetAllActiveBuyers = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get('/GetAllActiveBuyers', {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setbuyerData(res.data);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  // get all Style data
  const getAllStyles = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get('/getAllDailyStyles', {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setstyleData(res.data);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

     const getStyles = async () => {
      setOpenLoader(true);
      try {
        const res = await axios.instance.get('/getStyles', {
          headers: { Authorization: tokent, 'Content-Type': 'application/json' },
        });
        setstyleData(res.data);
        setOpenLoader(false);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
   
    const handleStyleFilter = (overall)=>{
      setOpenLoader(true);
      console.log(overall,'overall');
      
       if(overall)
        { 
          getStyles() 
        }
       else 
        { 
        getAllStyles() 
      }
        setOpenLoader(false);
    }
  // get all unit data
  const GetAllActiveProductionUnits = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get(`/GetAllActiveProductionUnits/${sessionStorage.getItem('UserID')}`, {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setUnitData(res.data);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  reportData.forEach((payment) => {
    const fullName = `${payment.FirstName} ${payment.LastName}`;
    if (!groupedPaymentsByName[fullName]) {
      groupedPaymentsByName[fullName] = [];
    }
    groupedPaymentsByName[fullName].push(payment);
  });

  const applyFilters = async () => {
    // if (Number(styleSelected.Srhid) === 0 || styleSelected.Srhid === '') {
    if ((reportType !== 'Style' && (Number(styleSelected.Srhid) === 0 || styleSelected.Srhid === ''))) {
      setShowNoResultsSnackbar(true);
      setNoResultsMessage('Please Select Style');
    } else {
      setOpenLoader(true);
      try {
        const OBid = overall ? styleSelected.Srhid : 0 ;
        const TSid = overall ? 0 : styleSelected.Srhid ;
        const res = await axios.instance.post(
          `/getDailyTrackerReport`,
          {
            BuyerId: buyerSelected.Buyer_Id,
            // FromDate: reportType === 'Day' ? '' : fromDate,
            FromDate: reportType === 'Day' ? dateFilterEnabled ? fromDate : '':fromDate,
            ToDate: toDate,
            styleId: TSid,
            factoryId: unitSelected.Unit_Id,
            YearFilter: selectedYear,
            ReportType: reportType,
            OBid
          },
          {
            headers: { Authorization: tokent, 'Content-Type': 'application/json' },
          }
        );
        setFilteredData(res.data);
        setPage(0);
        setOpenLoader(false);
        setExpanded(false);
        if (res.data.length === 0) {
          setShowNoResultsSnackbar(true);
          setNoResultsMessage('No results found for the applied filters.');
        } else {
          if (reportType === 'Month') {
            const transformedData = res.data.map((item) => ({
              data: [item.MonthlyTarget, item.MonthlyActual, item.Deviation],
            }));
            const Data = [
              { label: 'Target', data: transformedData.map((item) => item.data[0]) },
              { label: 'Actual', data: transformedData.map((item) => item.data[1]) },
              {
                label: 'Deviation',
                data: transformedData.map((item) => (item.data[2] === 0 ? 0 : Math.abs(item.data[2]))),
              },
            ];
            setChartData(Data);
          } else if (reportType === 'Hour') {
            const Data = [
              { label: 'Target', data: [] },
              { label: 'Actual', data: [] },
              { label: 'Deviation', data: [] },
            ];
            res.data.forEach((item) => {
              if (item.HourType >= 'H1' && item.HourType <= 'H8') {
                Data[0].data.push(item.Target);
                Data[1].data.push(item.Actual);
                Data[2].data.push(item.Actual === 0 ? 0 : Math.abs(item.Deviation)); // Convert Deviation to positive
              }
            });
            setChartData(Data);
          }
          setShowNoResultsSnackbar(false);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    }
  };

  const handleCloseSnackbar = () => {
    setShowNoResultsSnackbar(false);
  };

  const handleExpansion = () => {
    setExpanded((prevExpanded) => !prevExpanded);
  };

  const handleselectedYearChange = (event) => {
    setSelectedYear(event.target.value);
  };

  const handleDateFilterToggle = (event) => {
    setDateFilterEnabled(event.target.checked);
  };

  return (
    <>
      <Container maxWidth={'xl'} sx={{ pt: 2, p: 1 }} elevation={3}>
        <Snackbar
          style={{ marginTop: '45px' }}
          open={showNoResultsSnackbar}
          autoHideDuration={4000}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          onClose={handleCloseSnackbar}
        >
          <Alert onClose={handleCloseSnackbar} severity="info" variant="filled" sx={{ width: '100%' }}>
            {noResultsMessage}
          </Alert>
        </Snackbar>

        <Grid justifyContent={'space-between'} alignItems={'center'} spacing={2} mb={2}>
          <Typography
            variant="h5"
            p={1}
            boxShadow={1}
            borderColor="#11235A"
            textAlign={'center'}
            borderRadius={2}
            pl={2}
            color="white"
            sx={{
              background: 'linear-gradient(to right, #134e5e, #71b280)',
              boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px',
            }}
          >
            <Typography variant="h6" color="white" className="font_style1" textAlign={'center'}>
              Production Tracker Report
            </Typography>
          </Typography>
        </Grid>

        {/* filters */}
        <Stack sx={{ border: '1px solid #CDE8E5', borderRadius: 4, my: 2 }}>
          <Accordion
            expanded={expanded}
            onChange={handleExpansion}
            disableGutters
            sx={{ borderTop: 'none', borderColor: 'black', backgroundColor: 'inherit' }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon style={{ color: '#36BA98' }} />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              sx={{ borderTop: 'none' }}
            >
              <Stack justifyContent={'start'} direction={'row'} alignItems={'center'} p={0} m={0}>
                <IconButton aria-label="ExpandMoreIcon" color="white">
                  <MastersIcon style={{ color: 'white', width: 24, height: 24 }} />
                </IconButton>
                <Typography
                  sx={{
                    color: '#36BA98',
                    '&.active': {
                      color: 'text.primary',
                      bgcolor: 'action.selected',
                      fontWeight: 'fontWeightBold',
                    },
                  }}
                  variant="h6"
                >
                  Filters
                </Typography>
              </Stack>
            </AccordionSummary>

            <AccordionDetails sx={{ borderTop: 'none', py: 0, pb: 2, pl: 3 }}>
              <Stack direction={'column'} justifyContent={'space-between'} spacing={2} my={1}>
                <Stack direction={{ sm: 'row', xs: 'column' }} spacing={1}>
                  <Grid container spacing={2} rowSpacing={2} columnSpacing={2}>
                    <Grid item xs={12}>
                      <Stack direction={'row'} justifyContent={'end'} spacing={2}>
                        <FormControl size="small" component="fieldset">
                          <Stack direction={'row'} justifyContent={'center'} alignItems={'center'} spacing={2}>
                            <RadioGroup
                              row
                              value={reportType}
                              onChange={(e) => {
                                setReportType(e.target.value);
                                resetFilters();
                                setStyleSelected({
                                  Srhid: '0',
                                  StyleDescription: `${e.target.value === 'Style' ? 'All' : 'Select Style'}`,
                                  StyleNumber: '',
                                  Line_Name: '',
                                });
                              }}
                            >
                              <FormControlLabel value="Hour" control={<Radio />} label="Hour Wise" />
                              <FormControlLabel value="Day" control={<Radio />} label="Day Wise" />
                              <FormControlLabel value="Month" control={<Radio />} label="Month Wise" />
                              <FormControlLabel value="Style" control={<Radio />} label="Style Wise" />
                            </RadioGroup>
                          </Stack>
                        </FormControl>
                      </Stack>
                    </Grid>

                    <Grid item xs={12} md={4}>
                      <FormControl size="small" fullWidth component="fieldset" required>
                        <Autocomplete
                          size="small"
                          fullWidth
                          options={
                            reportType === 'Style'
                              ? [{ Srhid: '0', StyleDescription: 'All', StyleNumber: '', Line_Name: ''  }, ...styleData]
                              : styleData
                          }
                          getOptionLabel={(obj) => obj.Srhid !== '0' && obj.Line_Name !== ''
                            ? `${obj.StyleDescription} - ${obj.StyleNumber} - ${obj.Line_Name}`  
                            : `${obj.StyleDescription} - ${obj.StyleNumber} `}
                          isOptionEqualToValue={(option, value) => option.Srhid === value.Srhid}
                          renderInput={(params) => (
                            <TextField {...params} label="Style" required={reportType !== 'Style'} />
                          )}
                          value={styleSelected}
                          onChange={(e, newValue) => {
                            setStyleSelected(newValue || { Srhid: '0', StyleDescription: `${reportType === 'Style' ? 'All' : 'Select Style'}`, });
                          }}
                          clearText="Clear"
                          disableClearable
                        />
                      </FormControl>
                    </Grid>
                     <Grid item xs={12} md={2}>
                        <SwitchContainer>
                                <input
                                  id={`manufacturerb`}
                                  className="checkboxfilter"
                                  type="checkbox"
                                  checked={overall}
                                  onClick={(e) => {
                                    // const newValue = !overall;
                                      setStyleSelected({
                                              Srhid: '0',
                                              StyleDescription: 'Select Style',
                                              StyleNumber: '',
                                              Line_Name: '',
                                            });
                                    handleStyleFilter(!overall);
                                    setOverall(!overall);
                                  }}
                                />{' '}
                                <Label
                                  htmlFor='manufacturerb'
                                  className=" font_stylechecklable text-dark-emphasis"
                                  style={{ color: '#468585' }}
                                >
                                  OverAll
                                </Label>
                              </SwitchContainer>
                      </Grid>

                    <Grid item xs={12} md={3}>
                      <FormControl size="small" fullWidth component="fieldset" required>
                        <Autocomplete
                          size="small"
                          fullWidth
                          options={[{ Buyer_Name: 'All', Buyer_Id: '0' }, ...buyerData]}
                          getOptionLabel={(obj) => obj.Buyer_Name}
                          isOptionEqualToValue={(option, value) => option.Buyer_Name === value.Buyer_Name}
                          renderInput={(params) => <TextField {...params} label="Buyer" />}
                          value={buyerSelected}
                          onChange={(e, newValue) => {
                            setbuyerSelected(newValue);
                          }}
                          clearText="Clear"
                          disableClearable
                        />
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <FormControl size="small" fullWidth component="fieldset" required>
                        <Autocomplete
                          size="small"
                          fullWidth
                          options={[{ Unit_Name: 'All', Unit_Id: '0' }, ...unitData]}
                          getOptionLabel={(obj) => obj.Unit_Name}
                          isOptionEqualToValue={(option, value) => option.Unit_Name === value.Unit_Name}
                          renderInput={(params) => <TextField {...params} label="Factory" />}
                          value={unitSelected}
                          onChange={(e, newValue) => {
                            setUnitSelected(newValue);
                          }}
                          clearText="Clear"
                          disableClearable
                        />
                      </FormControl>
                    </Grid>

                    {reportType === 'Day' && (
                      <Grid item xs={12} md={2}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={dateFilterEnabled}
                              onChange={handleDateFilterToggle}
                              name="dateFilter"
                              color="primary"
                            />
                          }
                          label="Enable Date Filter"
                          labelPlacement="start"
                        />
                      </Grid>
                    )}
                    {(reportType === 'Hour' || reportType === 'Day' || reportType === 'Style') && (
                      <>
                        {(reportType === 'Day' || reportType === 'Style') && (
                          <Grid item xs={12} md={3} lg={(reportType === 'Style') ? 3 : 2}>
                            <TextField
                              fullWidth
                              size="small"
                              label="From Date"
                              type="date"
                              value={fromDate}
                              min={'1000-01-01'}
                              max={'9999-12-31'}
                              onChange={(e) => {
                                if (e.target.value) setfromDate(e.target.value);
                              }}
                              InputLabelProps={{
                                shrink: true,
                              }}
                            />
                          </Grid>
                        )}
                        <Grid item xs={12} md={3} lg={(reportType === 'Hour') ? 6 : (reportType === 'Style') ? 3 : 2}>
                          <TextField
                            fullWidth
                            size="small"
                            label={`${reportType === 'Hour' ? 'On Date' : 'To Date'}`}
                            type="date"
                            value={toDate}
                            min={'1000-01-01'}
                            max={'9999-12-31'}
                            onChange={(e) => {
                              if (e.target.value) setToDate(e.target.value);
                            }}
                            InputLabelProps={{
                              shrink: true,
                            }}
                          />
                        </Grid>
                      </>
                    )}
                    {reportType === 'Month' && (
                      <Grid item lg={6} md={6} xs={12}>
                        <FormControl fullWidth>
                          <InputLabel id="year-select-label">Year</InputLabel>
                          <Select
                            labelId="year-select-label"
                            id="year-select"
                            value={selectedYear}
                            size="small"
                            label="Year"
                            onChange={handleselectedYearChange}
                          >
                            {selectedYears.map((year) => (
                              <MenuItem key={year} value={year}>
                                {year}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                    )}

                    <Grid item xs={12} md={6}>
                      <Stack direction={{ xs: 'row' }} spacing={1} justifyContent={'end'}>
                        <Stack direction={'row'} spacing={1}>
                          <Button
                            variant="contained"
                            color="secondary"
                            onClick={() => applyFilters()}
                            startIcon={<FilterAltIcon />}
                            sx={{ boxShadow: 0 }}
                          >
                            Apply Filters
                          </Button>
                          <Button
                            variant="contained"
                            color="warning"
                            onClick={resetFilters}
                            startIcon={<LockResetIcon />}
                            sx={{ boxShadow: 0 }}
                          >
                            reset
                          </Button>
                        </Stack>
                      </Stack>
                    </Grid>
                  </Grid>
                </Stack>
              </Stack>
            </AccordionDetails>
          </Accordion>
        </Stack>

        <Collapse in={filteredData.length > 0}>
          <>
            <Stack direction={{ xs: 'row' }} spacing={1} justifyContent={'end'} alignItems={'center'} mb={2}>
              {filteredData.length > 0 && (
                <>
                  {(reportType === 'Hour' || reportType === 'Month') && (
                    <Button
                      variant="outlined"
                      startIcon={<BarChartIcon />}
                      onClick={handleEfficiencyDetailsOpen}
                      color="info"
                      aria-label="Show Chart"
                    >
                      Show Chart
                    </Button>
                  )}
                </>
              )}
            </Stack>

            {filteredData.length > 0 && (reportType === 'Day' || reportType === 'Style') && (
              <>
                <Grid container spacing={2} rowSpacing={2} columnSpacing={2} mb={2} mx={2}>
                  <Grid item xs={12}>
                    <Grid container spacing={2} rowSpacing={2} columnSpacing={2}>
                      <Grid item xs={12} lg={2} md={4}>
                        <Stack justifyContent={'flex-start'} direction={'column'}>
                          <Typography variant="subtitle2" color="GrayText" pr={1}>
                            Total Target Pcs
                          </Typography>
                          <Typography variant="subtitle2" color="#009688">
                            {numeral(Math.abs(filteredData.reduce((sum, enq) => sum + enq.Target, 0))).format('0,0.00')}
                            {/* <span style={{ color: '#6EC207' }}>
                              {`(${numeral(
                                Math.abs(filteredData.reduce((sum, enq) => (sum + enq.LineEffecient), 0))
                              ).format('0,0.00') / filteredData.length}%)`}
                            </span> */}
                          </Typography>
                        </Stack>
                      </Grid>
                      <Grid item xs={12} lg={2} md={4}>
                        <Stack justifyContent={'flex-start'} direction={'column'}>
                          <Typography variant="subtitle2" color="GrayText" pr={1}>
                            Target Value Total
                          </Typography>
                          <Typography variant="subtitle2" color="#009688">
                            {numeral(Math.abs(filteredData.reduce((sum, enq) => sum + enq.TargetValue, 0))).format(
                              '0,0.00'
                            )}
                          </Typography>
                        </Stack>
                      </Grid>
                      <Grid item xs={12} lg={2} md={4}>
                        <Stack justifyContent={'flex-start'} direction={'column'}>
                          <Typography variant="subtitle2" color="GrayText" pr={1}>
                            Total Actual Pcs
                          </Typography>
                          <Typography variant="subtitle2" color="#009688">
                            {numeral(Math.abs(filteredData.reduce((sum, enq) => sum + enq.Actual, 0))).format('0,0.00')}{' '}
                            <span style={{ color: '#6EC207' }}>
                              {`(${numeral(
                                (filteredData.reduce((sum, enq) => sum + enq.Actual, 0) /
                                  filteredData.reduce((sum, enq) => sum + enq.Target, 0)) *
                                100
                              ).format('0,0.00')}%)`}
                            </span>
                          </Typography>
                        </Stack>
                      </Grid>
                      <Grid item xs={12} lg={2} md={4}>
                        <Stack justifyContent={'flex-start'} direction={'column'}>
                          <Typography variant="subtitle2" color="GrayText" pr={1}>
                            Actual Total Value
                          </Typography>
                          <Typography variant="subtitle2" color="#009688">
                            {numeral(Math.abs(filteredData.reduce((sum, enq) => sum + enq.ActualValue, 0))).format(
                              '0,0.00'
                            )}
                          </Typography>
                        </Stack>
                      </Grid>
                      <Grid item xs={12} lg={2} md={4}>
                        <Stack justifyContent={'flex-start'} direction={'column'}>
                          <Typography variant="subtitle2" color="GrayText" pr={1}>
                            Total Deviation
                          </Typography>
                          <Typography variant="subtitle2" color="#009688">
                            <span style={{ display: 'flex', alignItems: 'start', justifyContent: 'start' }}>
                              {filteredData.reduce((sum, enq) => sum + enq.Actual, 0) === 0 ? (
                                0
                              ) : filteredData.reduce((sum, enq) => sum + enq.Deviation, 0) > 0 ? (
                                <>
                                  <ArrowDropUpIcon sx={{ color: 'green' }} />
                                  <span style={{ marginLeft: '4px' }}>
                                    {numeral(filteredData.reduce((sum, enq) => sum + enq.Deviation, 0)).format('0,0.00')}
                                  </span>
                                </>
                              ) : (
                                <>
                                  <ArrowDropDownIcon sx={{ color: 'red' }} />
                                  <span style={{ marginLeft: '4px' }}>
                                    {numeral(Math.abs(filteredData.reduce((sum, enq) => sum + enq.Deviation, 0))).format('0,0.00')}
                                  </span>
                                </>
                              )}
                            </span>
                          </Typography>
                        </Stack>
                      </Grid>
                      <Grid item xs={12} lg={2} md={4}>
                        <Stack justifyContent={'flex-start'} direction={'column'}>
                          <Typography variant="subtitle2" color="GrayText" pr={1}>
                            Total Deviation Value
                          </Typography>
                          <Typography variant="subtitle2" color="#009688">
                            <span style={{ display: 'flex', alignItems: 'start', justifyContent: 'start' }}>
                              {filteredData.reduce((sum, enq) => sum + enq.ActualValue, 0) === 0 ? (
                                0
                              ) : filteredData.reduce((sum, enq) => sum + enq.DeviationValue, 0) > 0 ? (
                                <>
                                  <ArrowDropUpIcon sx={{ color: 'green' }} />
                                  <span style={{ marginLeft: '4px' }}>
                                    {numeral(filteredData.reduce((sum, enq) => sum + enq.DeviationValue, 0)).format('0,0.00')}
                                  </span>
                                </>
                              ) : (
                                <>
                                  <ArrowDropDownIcon sx={{ color: 'red' }} />
                                  <span style={{ marginLeft: '4px' }}>
                                    {numeral(Math.abs(filteredData.reduce((sum, enq) => sum + enq.DeviationValue, 0))).format('0,0.00')}
                                  </span>
                                </>
                              )}
                            </span>

                          </Typography>
                        </Stack>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </>
            )}

            {reportType === 'Hour' && (
              <TableContainer sx={{ borderRadius: 1, backgroundColor: 'inherit' }} elevation={4} component={Paper}>
                <Table size="small">
                  <TableHead>
                    <TableRow sx={{ padding: 'none' }}>
                      <StyledTableCell align="center">Hours</StyledTableCell>
                      <StyledTableCell align="right">Target</StyledTableCell>
                      <StyledTableCell align="right">Target Value</StyledTableCell>
                      <StyledTableCell align="right">Actual</StyledTableCell>
                      <StyledTableCell align="right">Actual Value</StyledTableCell>
                      <StyledTableCell align="right">Deviation</StyledTableCell>
                      <StyledTableCell align="right">Deviation Value</StyledTableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {(rowsPerPage > 0
                      ? filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      : filteredData
                    ).map((enq, index, array) => (
                      <React.Fragment key={index}>
                        <TableRow hover>
                          <TableCell
                            align="center"
                            padding="normal"
                            sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                          >
                            {enq.HourType}
                          </TableCell>
                          <TableCell
                            align="right"
                            padding="normal"
                            sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                          >
                            {enq.Target}
                          </TableCell>
                          <TableCell
                            align="right"
                            padding="normal"
                            sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                          >
                            {enq.TargetValue}
                          </TableCell>
                          <TableCell
                            align="right"
                            padding="normal"
                            sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                          >
                            {enq.Actual}
                          </TableCell>
                          <TableCell
                            align="right"
                            padding="normal"
                            sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                          >
                            {enq.ActualValue}
                          </TableCell>
                          {/* <TableCell
                            align="right"
                            padding="normal"
                            sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                          >
                            {enq.Actual === 0 ? 0 : enq.Deviation}
                          </TableCell> */}
                          {/* <TableCell
                            align="right"
                            padding="normal"
                            sx={{ textTransform: 'uppercase', whiteSpace: 'nowrap' }}
                          >
                            {enq.ActualValue === 0 ? 0 : enq.DeviationValue}
                          </TableCell> */}
                          <TableCell
                            align="right"
                            padding="normal"
                            sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                          >
                            <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'right' }}>
                              {enq.Actual === 0 ? (
                                0
                              ) : enq.Deviation > 0 ? (
                                <>
                                  <ArrowDropUpIcon sx={{ color: '#6EC207' }} />
                                  <span style={{ marginLeft: '4px' }}>{numeral(enq.Deviation).format('0,0.00')}</span>
                                </>
                              ) : (
                                <>
                                  <ArrowDropDownIcon sx={{ color: 'red' }} />
                                  <span style={{ marginLeft: '4px' }}>
                                    {numeral(Math.abs(enq.Deviation)).format('0,0.00')}
                                  </span>
                                </>
                              )}
                            </span>
                          </TableCell>

                          <TableCell
                            align="right"
                            padding="normal"
                            sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                          >
                            <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'right' }}>
                              {enq.ActualValue === 0 ? (
                                0
                              ) : enq.DeviationValue > 0 ? (
                                <>
                                  <ArrowDropUpIcon sx={{ color: 'green' }} />
                                  <span style={{ marginLeft: '4px' }}>
                                    {numeral(enq.DeviationValue).format('0,0.00')}
                                  </span>
                                </>
                              ) : (
                                <>
                                  <ArrowDropDownIcon sx={{ color: 'red' }} />
                                  <span style={{ marginLeft: '4px' }}>
                                    {numeral(Math.abs(enq.DeviationValue)).format('0,0.00')}
                                  </span>
                                </>
                              )}
                            </span>
                          </TableCell>
                        </TableRow>

                        {/* Add a total row after H8 */}
                        {(enq.HourType === 'H8' || enq.HourType === 'H12') && (
                          <TableRow style={{ backgroundColor: '#83c5be' }}>
                            <TableCell align="center" padding="normal" sx={{ fontWeight: 'bold' }}>
                              Total
                            </TableCell>
                            <TableCell align="right" padding="normal" sx={{ fontWeight: 'bold' }}>
                              {/* Total Target */}
                              {array
                                .filter((item, idx) => {
                                  if (enq.HourType === 'H8') return idx <= index;
                                  if (enq.HourType === 'H12')
                                    return idx > array.findIndex((e) => e.HourType === 'H8') && idx <= index;
                                  return false;
                                })
                                .reduce((acc, item) => acc + item.Target, 0)}
                            </TableCell>
                            <TableCell align="right" padding="normal" sx={{ fontWeight: 'bold' }}>
                              {/* Total TargetValue */}
                              {array
                                .filter((item, idx) => {
                                  if (enq.HourType === 'H8') return idx <= index;
                                  if (enq.HourType === 'H12')
                                    return idx > array.findIndex((e) => e.HourType === 'H8') && idx <= index;
                                  return false;
                                })
                                .reduce((acc, item) => acc + item.TargetValue, 0)}
                            </TableCell>
                            <TableCell align="right" padding="normal" sx={{ fontWeight: 'bold' }}>
                              {/* Total Actual */}
                              {array
                                .filter((item, idx) => {
                                  if (enq.HourType === 'H8') return idx <= index;
                                  if (enq.HourType === 'H12')
                                    return idx > array.findIndex((e) => e.HourType === 'H8') && idx <= index;
                                  return false;
                                })
                                .reduce((acc, item) => acc + item.Actual, 0)}
                            </TableCell>
                            <TableCell align="right" padding="normal" sx={{ fontWeight: 'bold' }}>
                              {/* Total ActualValue */}
                              {array
                                .filter((item, idx) => {
                                  if (enq.HourType === 'H8') return idx <= index;
                                  if (enq.HourType === 'H12')
                                    return idx > array.findIndex((e) => e.HourType === 'H8') && idx <= index;
                                  return false;
                                })
                                .reduce((acc, item) => acc + item.ActualValue, 0)}
                            </TableCell>
                            {/* <TableCell align="right" padding="normal" sx={{ fontWeight: 'bold' }}>
                              {array
                                .filter((item, idx) => {
                                  if (enq.HourType === 'H8') return idx <= index;
                                  if (enq.HourType === 'H12') return idx > array.findIndex(e => e.HourType === 'H8') && idx <= index;
                                  return false;
                                })
                                .reduce((acc, item) => acc + (item.Actual === 0 ? 0 : item.Deviation), 0)}
                            </TableCell>
                            <TableCell align="right" padding="normal" sx={{ fontWeight: 'bold' }}>

                              {array
                                .filter((item, idx) => {
                                  if (enq.HourType === 'H8') return idx <= index;
                                  if (enq.HourType === 'H12') return idx > array.findIndex(e => e.HourType === 'H8') && idx <= index;
                                  return false;
                                })
                                .reduce((acc, item) => acc + (item.ActualValue === 0 ? 0 : item.DeviationValue), 0)}
                            </TableCell> */}

                            <TableCell align="right" padding="normal" sx={{ fontWeight: 'bold' }}>
                              {/* Total Deviation */}
                              <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'right' }}>
                                {(() => {
                                  const totalDeviation = array
                                    .filter((item, idx) => {
                                      if (enq.HourType === 'H8') return idx <= index;
                                      if (enq.HourType === 'H12')
                                        return idx > array.findIndex((e) => e.HourType === 'H8') && idx <= index;
                                      return false;
                                    })
                                    .reduce((acc, item) => acc + (item.Actual === 0 ? 0 : item.Deviation), 0);

                                  return totalDeviation === 0 ? (
                                    0
                                  ) : totalDeviation > 0 ? (
                                    <>
                                      <ArrowDropUpIcon sx={{ color: 'green' }} />
                                      <span style={{ marginLeft: '4px' }}>
                                        {numeral(totalDeviation).format('0,0.00')}
                                      </span>
                                    </>
                                  ) : (
                                    <>
                                      <ArrowDropDownIcon sx={{ color: 'red' }} />
                                      <span style={{ marginLeft: '4px' }}>
                                        {numeral(Math.abs(totalDeviation)).format('0,0.00')}
                                      </span>
                                    </>
                                  );
                                })()}
                              </span>
                            </TableCell>

                            <TableCell align="right" padding="normal" sx={{ fontWeight: 'bold' }}>
                              {/* Total DeviationValue */}
                              <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'right' }}>
                                {(() => {
                                  const totalDeviationValue = array
                                    .filter((item, idx) => {
                                      if (enq.HourType === 'H8') return idx <= index;
                                      if (enq.HourType === 'H12')
                                        return idx > array.findIndex((e) => e.HourType === 'H8') && idx <= index;
                                      return false;
                                    })
                                    .reduce((acc, item) => acc + (item.ActualValue === 0 ? 0 : item.DeviationValue), 0);

                                  return totalDeviationValue === 0 ? (
                                    0
                                  ) : totalDeviationValue > 0 ? (
                                    <>
                                      <ArrowDropUpIcon sx={{ color: 'green' }} />
                                      <span style={{ marginLeft: '4px' }}>
                                        {numeral(totalDeviationValue).format('0,0.00')}
                                      </span>
                                    </>
                                  ) : (
                                    <>
                                      <ArrowDropDownIcon sx={{ color: 'red' }} />
                                      <span style={{ marginLeft: '4px' }}>
                                        {numeral(Math.abs(totalDeviationValue)).format('0,0.00')}
                                      </span>
                                    </>
                                  );
                                })()}
                              </span>
                            </TableCell>
                          </TableRow>
                        )}
                      </React.Fragment>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}

            {reportType === 'Day' && (
              <TableContainer sx={{ borderRadius: 1, backgroundColor: 'inherit' }} elevation={4} component={Paper}>
                <Table size="small">
                  <TableHead>
                    <TableRow sx={{ padding: 'none' }}>
                      <StyledTableCell align="center">Date</StyledTableCell>
                      <StyledTableCell align="right">Target</StyledTableCell>
                      <StyledTableCell align="right">Target Value</StyledTableCell>
                      <StyledTableCell align="right">Actual</StyledTableCell>
                      <StyledTableCell align="right">Actual Value</StyledTableCell>
                      <StyledTableCell align="right">Deviation</StyledTableCell>
                      <StyledTableCell align="right">Deviation Value</StyledTableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {(rowsPerPage > 0
                      ? filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      : filteredData
                    ).map((enq, index) => (
                      <TableRow key={index} hover>
                        <TableCell
                          align="center"
                          padding="normal"
                          sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                        >
                          {enq.DailyProddate}
                        </TableCell>
                        <TableCell
                          align="right"
                          padding="normal"
                          sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                        >
                          {enq.Target}
                          <span style={{ color: '#6EC207' }}>{`(${enq.LineEffecient}%)`}</span>
                        </TableCell>
                        <TableCell
                          align="right"
                          padding="normal"
                          sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                        >
                          {enq.TargetValue}
                        </TableCell>
                        <TableCell
                          align="right"
                          padding="normal"
                          sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                        >
                          {enq.Actual}{' '}
                          <span style={{ color: '#6EC207' }}>
                            {`(${((enq.Actual / enq.Target) * 100).toFixed(2)}%)`}
                          </span>
                        </TableCell>

                        <TableCell
                          align="right"
                          padding="normal"
                          sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                        >
                          {enq.ActualValue}
                        </TableCell>

                        {/* <TableCell
                          align="right"
                          padding="normal"
                          sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                        >
                          {enq.Actual === 0 ? 0 : enq.Deviation}
                        </TableCell>

                        <TableCell
                          align="right"
                          padding="normal"
                          sx={{ textTransform: 'uppercase', whiteSpace: 'nowrap' }}
                        >
                          {enq.ActualValue === 0 ? 0 : enq.DeviationValue}
                        </TableCell> */}
                        <TableCell
                          align="right"
                          padding="normal"
                          sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                        >
                          <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'right' }}>
                            {enq.Actual === 0 ? (
                              0
                            ) : enq.Deviation > 0 ? (
                              <>
                                <ArrowDropUpIcon sx={{ color: 'green' }} />
                                <span style={{ marginLeft: '4px' }}>{numeral(enq.Deviation).format('0,0.00')}</span>
                              </>
                            ) : (
                              <>
                                <ArrowDropDownIcon sx={{ color: 'red' }} />
                                <span style={{ marginLeft: '4px' }}>
                                  {numeral(Math.abs(enq.Deviation)).format('0,0.00')}
                                </span>
                              </>
                            )}
                          </span>
                        </TableCell>

                        <TableCell
                          align="right"
                          padding="normal"
                          sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                        >
                          <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'right' }}>
                            {enq.ActualValue === 0 ? (
                              0
                            ) : enq.DeviationValue > 0 ? (
                              <>
                                <ArrowDropUpIcon sx={{ color: 'green' }} />
                                <span style={{ marginLeft: '4px' }}>
                                  {numeral(enq.DeviationValue).format('0,0.00')}
                                </span>
                              </>
                            ) : (
                              <>
                                <ArrowDropDownIcon sx={{ color: 'red' }} />
                                <span style={{ marginLeft: '4px' }}>
                                  {numeral(Math.abs(enq.DeviationValue)).format('0,0.00')}
                                </span>
                              </>
                            )}
                          </span>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}

            {reportType === 'Month' && (
              <TableContainer sx={{ borderRadius: 1, backgroundColor: 'inherit' }} elevation={4} component={Paper}>
                <Table size="small">
                  <TableHead>
                    <TableRow sx={{ padding: 'none' }}>
                      <StyledTableCell align="center">Month</StyledTableCell>
                      <StyledTableCell align="right">Target</StyledTableCell>
                      <StyledTableCell align="right">Target Value</StyledTableCell>
                      <StyledTableCell align="right">Actual</StyledTableCell>
                      <StyledTableCell align="right">Actual Value</StyledTableCell>
                      <StyledTableCell align="right">Deviation</StyledTableCell>
                      <StyledTableCell align="right">Deviation Value</StyledTableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {(rowsPerPage > 0
                      ? filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      : filteredData
                    ).map((enq, index) => (
                      <TableRow key={index} hover>
                        <TableCell
                          align="center"
                          padding="normal"
                          sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                        >
                          {enq.MonthName}
                        </TableCell>
                        <TableCell
                          align="right"
                          padding="normal"
                          sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                        >
                          {enq.MonthlyTarget}
                        </TableCell>
                        <TableCell
                          align="right"
                          padding="normal"
                          sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                        >
                          {enq.MonthlyValue}
                        </TableCell>
                        <TableCell
                          align="right"
                          padding="normal"
                          sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                        >
                          {enq.MonthlyActual}
                        </TableCell>
                        <TableCell
                          align="right"
                          padding="normal"
                          sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                        >
                          {enq.MonthlyActualValue}
                        </TableCell>
                        {/* <TableCell
                          align="right"
                          padding="normal"
                          sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                        >
                          {enq.MonthlyActual === 0 ? 0 : enq.Deviation}
                        </TableCell>

                        <TableCell
                          align="right"
                          padding="normal"
                          sx={{ textTransform: 'uppercase', whiteSpace: 'nowrap' }}
                        >
                          {enq.MonthlyActualValue === 0 ? 0 : enq.DeviationValue}
                        </TableCell> */}
                        <TableCell
                          align="right"
                          padding="normal"
                          sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                        >
                          <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'right' }}>
                            {enq.MonthlyActual === 0 ? (
                              0
                            ) : enq.Deviation > 0 ? (
                              <>
                                <ArrowDropUpIcon sx={{ color: 'green' }} />
                                <span style={{ marginLeft: '4px' }}>{numeral(enq.Deviation).format('0,0.00')}</span>
                              </>
                            ) : (
                              <>
                                <ArrowDropDownIcon sx={{ color: 'red' }} />
                                <span style={{ marginLeft: '4px' }}>
                                  {numeral(Math.abs(enq.Deviation)).format('0,0.00')}
                                </span>
                              </>
                            )}
                          </span>
                        </TableCell>

                        <TableCell
                          align="right"
                          padding="normal"
                          sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                        >
                          <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'right' }}>
                            {enq.MonthlyActualValue === 0 ? (
                              0
                            ) : enq.DeviationValue > 0 ? (
                              <>
                                <ArrowDropUpIcon sx={{ color: 'green' }} />
                                <span style={{ marginLeft: '4px' }}>
                                  {numeral(enq.DeviationValue).format('0,0.00')}
                                </span>
                              </>
                            ) : (
                              <>
                                <ArrowDropDownIcon sx={{ color: 'red' }} />
                                <span style={{ marginLeft: '4px' }}>
                                  {numeral(Math.abs(enq.DeviationValue)).format('0,0.00')}
                                </span>
                              </>
                            )}
                          </span>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}

            {reportType === 'Style' && (
              <TableContainer sx={{ borderRadius: 1, backgroundColor: 'inherit' }} elevation={4} component={Paper}>
                <Table size="small">
                  <TableHead>
                    <TableRow sx={{ padding: 'none' }}>
                      <StyledTableCell align="center">S No</StyledTableCell>
                      <StyledTableCell align="right">Prod Start Date</StyledTableCell>
                      <StyledTableCell align="center">Style</StyledTableCell>
                      <StyledTableCell align="center">Style Description</StyledTableCell>
                      <StyledTableCell align="right">Style Number</StyledTableCell>
                      <StyledTableCell align="center">Factory</StyledTableCell>
                      <StyledTableCell align="center">Line</StyledTableCell>
                      <StyledTableCell align="right">Target Pcs</StyledTableCell>
                      <StyledTableCell align="right">Target Values</StyledTableCell>
                      <StyledTableCell align="right">Actual Pcs</StyledTableCell>
                      <StyledTableCell align="right">Actual Values</StyledTableCell>
                      <StyledTableCell align="right">Deviation</StyledTableCell>
                      <StyledTableCell align="right">Deviation Value</StyledTableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {(rowsPerPage > 0
                      ? filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      : filteredData
                    ).map((enq, index) => (
                      <TableRow key={index} hover>
                        <TableCell
                          align="center"
                          padding="normal"
                          sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                        >
                          {enq.sno}
                        </TableCell>
                        <TableCell
                          align="right"
                          padding="normal"
                          sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                        >
                          {enq.StartDate}
                        </TableCell>
                        <TableCell
                          align="center"
                          padding="normal"
                          sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                        >
                          <Stack
                            direction="row"
                            alignItems="center"
                            justifyContent={'center'}
                            spacing={1}
                            style={{ cursor: 'pointer' }}
                          >
                            <Box>
                              <img
                                src={
                                  enq.OBImage === '' ? NoimageFound : `${axios.baseURL}OperationBulletin/${enq.OBImage}`
                                }
                                alt="imgfor"
                                className={classes.chooseFileButton}
                                style={{ maxWidth: '50px', maxHeight: '50px', objectFit: 'contain' }}
                              />
                            </Box>
                          </Stack>
                        </TableCell>
                        <TableCell
                          align="left"
                          padding="normal"
                          sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                        >
                          {enq.StyleDescription}
                        </TableCell>
                        <TableCell
                          align="left"
                          padding="normal"
                          sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                        >
                          {enq.StyleNumber}
                        </TableCell>
                        <TableCell
                          align="left"
                          padding="normal"
                          sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                        >
                          {enq.Unit_Name}
                        </TableCell>
                        <TableCell
                          align="left"
                          padding="normal"
                          sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                        >
                          {enq.Line_Name}
                        </TableCell>
                        <TableCell
                          align="right"
                          padding="normal"
                          sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                        >
                          {numeral(enq.Target).format('0,0.00')}
                          <span style={{ color: '#6EC207' }}>{`(${enq.LineEffecient}%)`}</span>
                        </TableCell>
                        <TableCell
                          align="right"
                          padding="normal"
                          sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                        >
                          {numeral(enq.TargetValue).format('0,0.00')}
                        </TableCell>
                        <TableCell
                          align="right"
                          padding="normal"
                          sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                        >
                          {numeral(enq.Actual).format('0,0.00')}

                          <span style={{ color: '#6EC207' }}>
                            {`(${((enq.Actual / enq.Target) * 100).toFixed(2)}%)`}
                          </span>
                        </TableCell>
                        <TableCell
                          align="right"
                          padding="normal"
                          sx={{ textTransform: 'uppercase', whiteSpace: 'nowrap' }}
                        >
                          {numeral(enq.ActualValue).format('0,0.00')}
                        </TableCell>
                        <TableCell
                          align="right"
                          padding="normal"
                          sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                        >
                          <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'right' }}>
                            {enq.Actual === 0 ? (
                              0
                            ) : enq.Deviation > 0 ? (
                              <>
                                <ArrowDropUpIcon sx={{ color: 'green' }} />
                                <span style={{ marginLeft: '4px' }}>{numeral(enq.Deviation).format('0,0.00')}</span>
                              </>
                            ) : (
                              <>
                                <ArrowDropDownIcon sx={{ color: 'red' }} />
                                <span style={{ marginLeft: '4px' }}>
                                  {numeral(Math.abs(enq.Deviation)).format('0,0.00')}
                                </span>
                              </>
                            )}
                          </span>
                        </TableCell>
                        <TableCell
                          align="right"
                          padding="normal"
                          sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                        >
                          <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'right' }}>
                            {enq.ActualValue === 0 ? (
                              0
                            ) : enq.DeviationValue > 0 ? (
                              <>
                                <ArrowDropUpIcon sx={{ color: 'green' }} />
                                <span style={{ marginLeft: '4px' }}>{numeral(enq.DeviationValue).format('0,0.00')}</span>
                              </>
                            ) : (
                              <>
                                <ArrowDropDownIcon sx={{ color: 'red' }} />
                                <span style={{ marginLeft: '4px' }}>
                                  {numeral(Math.abs(enq.DeviationValue)).format('0,0.00')}
                                </span>
                              </>
                            )}
                          </span>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}

            {/* pagination */}
            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={totalRows}
              rowsPerPage={rowsPerPage}
              page={currentPage} // Use the calculated currentPage value
              onPageChange={(event, newPage) => setPage(newPage)}
              onRowsPerPageChange={(event) => {
                setRowsPerPage(parseInt(event.target.value, 10));
                setPage(0); // Reset the page when rowsPerPage changes
              }}
              mt={2}
            />
          </>
        </Collapse>
      </Container>

      {/* loader popup dialog box */}
      <Dialog
        open={openLoader}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <LinearProgress />
      </Dialog>

      {/* show Hourwise Efficieny details */}
      <Dialog open={efficiencyDetailsOpen} onClose={handleEfficiencyDetailsClose} maxWidth="lg" fullScreen>
        <DialogTitle>
          {reportType === 'Month' ? 'Monthwise Chart' : reportType === 'Hour' && 'Hourwise Chart'}
        </DialogTitle>
        <DialogContent>
          {reportType === 'Month' && (
            <BarChart
              xAxis={[
                {
                  scaleType: 'band',
                  data: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                },
              ]}
              series={chartData}
              width={1200}
              height={460}
              tooltip={{ enabled: true }}
            />
          )}
          {reportType === 'Hour' && (
            <BarChart
              xAxis={[{ scaleType: 'band', data: ['H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'H7', 'H8'] }]}
              series={chartData}
              width={1200}
              height={460}
              tooltip={{ enabled: true }}
            />
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleEfficiencyDetailsClose}>Close</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DailyReportTrackerReport;
